import { useContent } from "@/context/ContentContext";
import PagePlacements from "@/components/PagePlacements";

// Parsuje tekst regulaminu: linie zaczynające się od "## " to sekcje,
// paragrafy w sekcji są rozdzielone nowymi liniami.
function parseRegulaminBody(body) {
  if (!body) return [];
  const lines = body.split(/\r?\n/);
  const sections = [];
  let cur = null;
  for (const raw of lines) {
    const line = raw.trim();
    if (line.startsWith("## ")) {
      if (cur) sections.push(cur);
      cur = { title: line.slice(3).trim(), paragraphs: [] };
    } else if (line === "") {
      // pusta linia — separator paragrafu (bez akcji, każda linia to paragraf)
    } else {
      if (!cur) cur = { title: "", paragraphs: [] };
      cur.paragraphs.push(line);
    }
  }
  if (cur) sections.push(cur);
  return sections;
}

export default function Regulamin() {
  const { pages } = useContent();
  const reg = pages?.regulamin || {};
  const sections = parseRegulaminBody(reg.body || "");

  return (
    <div data-testid="regulamin-page" className="relative max-w-4xl mx-auto px-6 py-20">
      <div className="text-white/70 text-xs uppercase tracking-widest font-semibold">Dokumenty</div>
      <h1 className="font-display text-4xl sm:text-5xl font-black text-white mt-3">{reg.title || "Regulamin"}</h1>
      {reg.subtitle && <p className="text-white/70 mt-3">{reg.subtitle}</p>}

      <div className="rm-card p-8 md:p-10 mt-10 space-y-8 leading-relaxed">
        {sections.length === 0 && (
          <p className="text-slate-500">Regulamin jest w przygotowaniu.</p>
        )}
        {sections.map((s, i) => (
          <section key={i} data-testid={`reg-section-${i}`}>
            {s.title && <h2 className="font-display text-2xl font-bold text-[#0f172a] mb-3">{s.title}</h2>}
            <div className="text-slate-700 space-y-2">
              {s.paragraphs.map((p, pi) => (
                <p key={pi}>{p}</p>
              ))}
            </div>
          </section>
        ))}
      </div>
      <PagePlacements page="regulamin" />
    </div>
  );
}
